export default __webpack_public_path__ + "static/media/resolucao-2019.5081fb3f.pdf";